import api from "@/utils/axios";

const PAYMENT_API_URL = `/orders`;

export default {
  namespaced: true,
  state: {
    loading: false,
    error: null,
  },
  mutations: {
    SET_LOADING(state, status) {
      state.loading = status;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    async addPayment({ commit }, { orderId, payload }) {
      commit("SET_LOADING", true);
      commit("SET_ERROR", null);
      try {
        const res = await api.post(
          `${PAYMENT_API_URL}/${orderId}/payments/`,
          payload
        );
        commit("order/SET_ORDER", res.data.order, { root: true });
        return res.data;
      } catch (err) {
        commit(
          "SET_ERROR",
          err.response?.data?.error || "Failed to add payment"
        );
        return null;
      } finally {
        commit("SET_LOADING", false);
      }
    },
  },
  getters: {
    paymentLoading: (state) => state.loading,
    paymentError: (state) => state.error,
  },
};
